/* SSC achievements: listens for game milestones, records them through the app
   proxy when the customer is signed in, and shows a quiet toast when something
   new unlocks. Definitions live in the ssc-account Worker. */
(function () {
  'use strict';
  var cfg = window.SSC_ACH || {};
  var PROXY = cfg.proxy || '/apps/ssc';
  var loggedIn = !!cfg.loggedIn;
  var PENDING_KEY = 'ssc-ach-pending';
  var SHOWN_KEY = 'ssc-ach-shown';
  var SYNC_KEY = 'ssc-ach-synced-at';
  var SYNC_EVERY = 6 * 3600 * 1000;

  function read(key) { try { var v = JSON.parse(localStorage.getItem(key) || 'null'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(key, arr) { try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {} }

  /* ---- toast ---- */
  var stack = null, queue = [], showing = false;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(def, note) {
    queue.push({ def: def, note: note });
    if (!showing) next();
  }
  function next() {
    var item = queue.shift();
    if (!item) { showing = false; return; }
    showing = true;
    if (!stack) { stack = document.createElement('div'); stack.className = 'ssc-ach-stack'; document.body.appendChild(stack); }
    var el = document.createElement('div');
    el.className = 'ssc-ach';
    el.setAttribute('role', 'status');
    el.innerHTML = '<div class="ssc-ach-seal" aria-hidden="true">' + esc(item.def.seal || '祝') + '</div><div>' +
      '<div class="ssc-ach-eyebrow">Achievement unlocked</div>' +
      '<div class="ssc-ach-title">' + esc(item.def.title) + '<i>.</i></div>' +
      (item.def.text ? '<div class="ssc-ach-text">' + esc(item.def.text) + '</div>' : '') +
      (item.note ? '<div class="ssc-ach-note">' + item.note + '</div>' : '') + '</div>';
    stack.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    var timer = setTimeout(hide, 6500);
    el.addEventListener('click', function () { clearTimeout(timer); hide(); });
    function hide() {
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); next(); }, 400);
    }
  }

  /* ---- recording ---- */
  var FALLBACK = {
    kt_space: { seal: '宇', title: 'Spacewalk', text: 'Kappa Throw: Kappa Kun reached space.' },
    kt_moon: { seal: '月', title: 'To the Moon', text: 'Kappa Throw: a Moon landing.' },
    kb_100k: { seal: '祭', title: 'Festival', text: 'Kagami Biraki: 100,000 cups poured.' },
    kb_million: { seal: '祝', title: 'One million cups', text: 'Kagami Biraki: a million cups. Fireworks.' },
    mk_perfect: { seal: '切', title: 'Perfect cut', text: 'Maguro Kaitai: a perfect cut.' },
    mk_complete: { seal: '鮪', title: 'Ceremony complete', text: 'Maguro Kaitai: every level cut.' },
    fr_first: { seal: '鋳', title: 'First roll', text: 'Forge Roll: a full three-spin session.' },
    fr_unique: { seal: '鍛', title: 'Unique find', text: 'Forge Roll: a Unique or Mythic landed.' },
    fr_double: { seal: '運', title: 'Ridiculous luck', text: 'Two Unique-or-better cards in one Forge Roll session.' },
    egg_button: { seal: '謎', title: 'What does this button do?', text: 'You found a hidden store easter egg.' }
  };

  function send(keys, sync, counts) {
    return fetch(PROXY + '/achievements/unlock', {
      method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ keys: keys, sync: !!sync, counts: counts || {} })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  function record(keys, counts) {
    keys = keys.filter(function (k, i, a) { return k && a.indexOf(k) === i; });
    if (!keys.length && !counts) return;
    if (loggedIn) {
      send(keys, false, counts).then(function (b) {
        (b.fresh || []).forEach(function (def) { toast(def); });
      }).catch(function () { stash(keys); });
    } else {
      stash(keys);
      var shown = read(SHOWN_KEY);
      keys.forEach(function (k) {
        if (shown.indexOf(k) > -1 || !FALLBACK[k]) return;
        shown.push(k);
        toast(FALLBACK[k], '<a href="/account">Sign in</a> to keep it on your account.');
      });
      write(SHOWN_KEY, shown);
    }
  }
  function stash(keys) {
    var pending = read(PENDING_KEY);
    keys.forEach(function (k) { if (pending.indexOf(k) === -1) pending.push(k); });
    write(PENDING_KEY, pending);
  }

  // Signed in: flush anything earned while signed out, and sync order-based
  // achievements a few times a day so "Regular" and friends pop up too.
  if (loggedIn) {
    var pending = read(PENDING_KEY);
    var last = Number(localStorage.getItem(SYNC_KEY) || 0);
    var due = Date.now() - last > SYNC_EVERY;
    if (pending.length || due) {
      send(pending, due).then(function (b) {
        write(PENDING_KEY, []);
        if (due) { try { localStorage.setItem(SYNC_KEY, String(Date.now())); } catch (e) {} }
        (b.fresh || []).forEach(function (def) { toast(def); });
      }).catch(function () {});
    }
  }

  /* ---- game hooks ---- */
  document.addEventListener('kappa:result', function (ev) {
    var tier = (ev.detail && ev.detail.tier || '').toUpperCase();
    if (tier === 'MOON') record(['kt_space', 'kt_moon']);
    else if (tier === 'SPACE') record(['kt_space']);
  });
  document.addEventListener('kagami:milestone', function (ev) {
    var at = Number(ev.detail && ev.detail.at || 0);
    if (at >= 1000000) record(['kb_100k', 'kb_million']);
    else if (at >= 100000) record(['kb_100k']);
  });
  document.addEventListener('maguro:level-complete', function (ev) {
    var d = ev.detail || {};
    var keys = [];
    if (Number(d.perfectCuts) > 0) keys.push('mk_perfect');
    if (d.completed) keys.push('mk_complete');
    record(keys);
  });
  document.addEventListener('forge:session-complete', function (ev) {
    var buckets = (ev.detail && ev.detail.buckets) || [];
    var keys = ['fr_first'];
    var rare = buckets.filter(function (b) { return b === 'unique' || b === 'mythic'; }).length;
    if (rare >= 1) keys.push('fr_unique');
    if (rare >= 2) keys.push('fr_double');
    record(keys, { fr_session: 1 });
  });

  // Hidden: the big red kanji stamp on any shell page, five quick taps.
  var eggTaps = [];
  document.addEventListener('click', function (ev) {
    var stamp = ev.target.closest && ev.target.closest('.sg-stamp');
    if (!stamp) return;
    var now = Date.now();
    eggTaps = eggTaps.filter(function (t) { return now - t < 3000; });
    eggTaps.push(now);
    if (eggTaps.length >= 5) { eggTaps = []; record(['egg_button']); }
  });

  // Contact form sent while signed in.
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.action && f.action.indexOf('/contact') > -1 && loggedIn) record(['contact_form']);
  });

  // Scholar: ten hours of the shop open in the foreground, signed in.
  if (loggedIn) {
    var TIME_KEY = 'ssc-ach-time';
    setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      var total = (Number(localStorage.getItem(TIME_KEY)) || 0) + 30;
      try { localStorage.setItem(TIME_KEY, String(total)); } catch (e) {}
      if (total >= 36000 && !localStorage.getItem(TIME_KEY + '-sent')) {
        try { localStorage.setItem(TIME_KEY + '-sent', '1'); } catch (e) {}
        record(['scholar']);
      }
    }, 30000);
  }

  // Manual trigger for tests and future hooks: SSCAchievements.unlock(['kt_moon'])
  window.SSCAchievements = { unlock: record, toast: toast };
})();
